import { SidebarLeft, SidebarRight } from '@/components/icons';
import { cn } from '@/lib/utils';

interface SidebarTogglePillProps {
    id?: string;
    side: 'left' | 'right';
    onClick: () => void;
    className?: string;
}

export function SidebarTogglePill({ id, side, onClick, className }: SidebarTogglePillProps) {
    const isLeft = side === 'left';
    const Icon = isLeft ? SidebarLeft : SidebarRight;
    const title = `Abrir painel ${isLeft ? 'esquerdo' : 'direito'}`;

    return (
        <button
            id={id}
            type="button"
            onClick={onClick}
            title={title}
            aria-label={title}
            className={cn(
                'absolute top-6 z-30 inline-flex h-10 w-12 items-center justify-center rounded-full bg-muted/95 text-muted-foreground shadow-sm ring-1 ring-border/70 transition-[background-color,color,box-shadow,transform] hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
                isLeft ? 'left-4' : 'right-4',
                className,
            )}
        >
            <Icon className="size-4" />
        </button>
    );
}
